"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinType = void 0;
/**
 * Registered coin types
 * https://github.com/satoshilabs/slips/blob/master/slip-0044.md
 */
var CoinType;
(function (CoinType) {
    CoinType[CoinType["Bitcoin"] = 0] = "Bitcoin";
    CoinType[CoinType["BitcoinTestnet"] = 1] = "BitcoinTestnet";
    CoinType[CoinType["Dogecoin"] = 3] = "Dogecoin";
    CoinType[CoinType["Ethereum"] = 60] = "Ethereum";
    CoinType[CoinType["Tron"] = 195] = "Tron";
    CoinType[CoinType["Cardano"] = 1815] = "Cardano";
    CoinType[CoinType["FileCoin"] = 461] = "FileCoin";
    CoinType[CoinType["Solana"] = 501] = "Solana";
    CoinType[CoinType["Casper"] = 506] = "Casper";
})(CoinType || (exports.CoinType = CoinType = {}));
